export const   FETCH_CHECKOUT_DATA_REQUEST =`FETCH_CHECKOUT_DATA_REQUEST`;
export const   FETCH_CHECKOUT_DATA_SUCESS =`FETCH_CHECKOUT_DATA_SUCESS`;
export const   FETCH_CHECKOUT_DATA_ERROR =`FETCH_CHECKOUT_DATA_ERROR`;
export const ADD_OR_UPDATE_PICKUP_POINT=`ADD_OR_UPDATE_PICKUP_POINT`;
export const ADD_OR_REMOVE_DISCOUNT=`ADD_OR_UPDATE_DISCOUNT`;
export const PICKUP_POINT_CLEAR=`PICKUP_POINT_CLEAR`;
